import React from 'react';
import { useEscapeKey } from '../hooks/useEscapeKey';

export default function StreakBreakModal({ habit, onClose, onStartFresh }) {
  useEscapeKey(onClose, !!habit);
  if (!habit) return null;

  const totalCompletions = habit.totalCompletions || 0;
  const bestStreak = habit.bestStreak || 0;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative w-full max-w-sm bg-white dark:bg-gray-800 rounded-2xl p-6 text-center animate-scale-in" role="dialog" aria-modal="true">
        <div className="text-5xl mb-3">💪</div>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
          Don't give up!
        </h2>
        <p className="text-gray-500 dark:text-gray-400 mb-4">
          Your streak for <span className="font-medium text-gray-700 dark:text-gray-200">{habit.name}</span> was
          broken, but look at what you've achieved:
        </p>

        <div className="grid grid-cols-2 gap-3 mb-6">
          <div className="bg-gray-50 dark:bg-gray-700 rounded-xl p-3">
            <p className="text-2xl font-bold" style={{ color: habit.color }}>
              {totalCompletions}
            </p>
            <p className="text-xs text-gray-500 dark:text-gray-400">Total completions</p>
          </div>
          <div className="bg-gray-50 dark:bg-gray-700 rounded-xl p-3">
            <p className="text-2xl font-bold" style={{ color: habit.color }}>
              {bestStreak}
            </p>
            <p className="text-xs text-gray-500 dark:text-gray-400">Best streak</p>
          </div>
        </div>

        <button
          onClick={() => {
            onStartFresh();
            onClose();
          }}
          className="w-full py-3 bg-primary-600 hover:bg-primary-700 text-white font-semibold rounded-xl transition-colors"
        >
          Start Fresh
        </button>
        <button
          onClick={onClose}
          className="w-full py-2 mt-2 text-gray-500 dark:text-gray-400 text-sm hover:text-gray-700 dark:hover:text-gray-300"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
